import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import "./index.css";
import LandingTerminsvertretung from "./LandingTerminsvertretung";
import Datenschutzerklaerung from "./Datenschutzerklaerung";
import Impressum from "./Impressum";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        <Route path="/" element={<LandingTerminsvertretung />} />
        <Route path="/datenschutz" element={<Datenschutzerklaerung />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
